export default {
  title: 'Skróty',
  links: {
    reservations: 'Rezerwacje',
    orders_portal: 'Logowanie do terminala',
    closed: 'Zamknięte?',
    menu: 'Zmień menu',
    payouts: 'Raporty wypłat',
    opening_hours: 'Godziny otwarcia',
  },
};
